import { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    const navCollapse = document.querySelector('.navbar-collapse');
    if (navCollapse && navCollapse.classList.contains('show')) {
      const bsCollapse = new window.bootstrap.Collapse(navCollapse, { toggle: false });
      bsCollapse.hide();
    }
  }, [location]);

  const navLinkClass = ({ isActive }) => (isActive ? 'nav-link active' : 'nav-link');

  return (
    <nav className="navbar navbar-expand-lg py-2  fixed-top">
      <div className="container">
        <NavLink className="navbar-brand" to="/">
         <img src="../../img/logo.webp" className="img-fluid" alt="logo" width="50" />
        </NavLink>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
         >
          <span className="bi bi-list text-white"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav mx-auto">
            <li className="nav-item"><NavLink className={navLinkClass} to="/">Home</NavLink></li>
            <li className="nav-item"><NavLink className={navLinkClass} to="/discover">Discover</NavLink></li>
            <li className="nav-item"><NavLink className={navLinkClass} to="/for-brands">For Brands</NavLink></li>
            <li className="nav-item"><NavLink className={navLinkClass} to="/about">About</NavLink></li>
          </ul>
         
        </div>
      </div>
    </nav>
  );
}